module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-inright02.057d58a5.svg";